import { useSelector } from 'react-redux';

import { selectReceiversFilteredByIds } from './reducers';

export const useGetRecipients = (recipientIds: number[]) =>
  useSelector(selectReceiversFilteredByIds)(recipientIds);
